














import Vue from 'vue'
import Drawer from '@/layout/Drawer.vue'
import Toolbar from '@/layout/Toolbar.vue'

export default Vue.extend({
  components: {
    appDrawer: Drawer,
    appToolbar: Toolbar,
  },
})
